<template>
  <div class="search-holder" :class="{sel: tfocus}" id="searchwidget">
    <div class="search-widget" :class="{noline: noline}">
      <input type="text" class="search-area" :placeholder="$nippets.search.searchBy" 
        v-on:focus="setFocused(true)" v-on:blur="setFocused(false)" v-model="search" v-on:keyup.enter="handleGo" 
        v-on:keydown.down="selDown" v-on:keydown.up="selUp" v-on:keydown.left="switchKind" v-on:keydown.right="switchKind" />
      <div class="close-area" v-on:click="clearSearch()" :class="{invis: hideClose}"></div>
      <div class="mag-area"></div>
      <div class="go-area" :class="{canGo: canGo}" v-on:click="handleGo">{{ $nippets.search.go }}</div>
    </div>
    <transition name="fade">
      <div class="search-results" v-show="showResults" :class="{right: right}" :style="{'max-height': mheight + 'px'}" ref="sugDiv">
        <div class="search-col" v-show="artists.length > 0">
          <div class="search-h3">{{ $nippets.artists }}</div>
          <div class="search-item" v-for="artist in artists" :key="artist.artist_id" :class="{sel: isSelected('artist', artist)}">
            <ix-router-link :to="getArtistLink(artist)"
              v-on:click.prevent.stop="showResults = false">{{ artist.formatted_name }}</ix-router-link>
          </div>
        </div>
        <div class="search-col" v-show="styles.length > 0">
          <div class="search-h3">{{ $nippets.styles }}</div>
          <div class="search-item" v-for="gallery in styles" :key="gallery.gallery_id" :class="{sel: isSelected('style', gallery)}">
            <ix-router-link :to="gallery.url"> {{ gallery.name }}</ix-router-link>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  props: {
    right: Boolean,
    noline: Boolean,
    animation: Boolean
  },
  data: function () {
    return {
      tfocus: false,
      search: '',
      artists: [],
      styles: [],
      showResults: false,
      martists: [],
      mstyles: [],
      canGo: false,
      selItem: { kind: 'none', value: {}},
      mheight: 400
    }
  },
  created: function () {
    this.loadData()
  },
  mounted: function () {
    document.body.addEventListener('click',  (e) => {
      if(this.showResults) {
        if(!this.$el.contains(e.target)) {
          this.showResults = false
        }
      }
    })
    window.addEventListener('scroll', () => {
      this.handleScroll()
    })
    this.handleScroll()
  },
  computed: {
    hideClose: function () {
      return this.search.length === 0
    }
  },
  methods: {
    getArtistLink (artist) {
      if(artist.illustrator) {
        return '/artists/' + artist.portfolio_url
      }
      return '/animators/' + artist.portfolio_url
    },
    handleScroll: function () {
      if(this.$refs.sugDiv) {
        var pos = this.$refs.sugDiv.getBoundingClientRect()
        var h = window.innerHeight
        var sz = h - pos.top
        this.mheight = sz - 20
      }
    },
    setFocused: function (f) {
      if(!f){
        this.tfocus = false
        //this.showResults = false
      }
      else {
        this.tfocus = true
        this.showResults = (this.styles.length + this.artists.length > 0)
      }
    },
    isSelected: function (kind, item) {
      if(this.selItem.kind !== kind) return false
      if(kind === 'artist') {
        return this.selItem.value.artist_id === item.artist_id
      }
      else if(kind === 'style') {
        return this.selItem.value.gallery_id === item.gallery_id
      }
      return false
    },
    loadData: async function () {
      let styles = await this.$store.dispatch('fetchGalleries')
      if(this.animation) {
        this.mstyles = styles.filter(el => el.animation === this.animation)
      }
      else {
        this.mstyles = styles.filter(el => el.gallery_id)
      }
      this.mstyles.sort((el, el2) => {
        return el.name.localeCompare(el2.name)
      })
      await this.$store.dispatch('fetchArtists')
      let res = this.$store.getters.nonExcludedArtists
      if(this.animation) {
        this.martists = res.filter(el => el.animation)
      } 
      else {
        this.martists = res.filter(el => el.artist_id)
      }
      
      this.martists.sort((el, el1) => { return el.name.localeCompare(el1.name) })
    },
    handleSearch: async function () {
      this.selItem = { kind: '', value: {} }
      this.canGo = false
      let msearch = this.search.toLocaleLowerCase()
      if(this.search.length > 0) {
        let res = this.martists.filter(el => {
          return el.formatted_name.toLowerCase().indexOf(msearch) >= 0
        })
        this.artists = res.slice(0,20) // max 20 returned
        this.styles = this.mstyles.filter(el => el.name.toLowerCase().indexOf(msearch) >= 0)
        
        if(this.artists.length === 0){
          if(this.styles.length > 0) {
            this.selItem = { kind: 'style', value: this.styles[0] }
          }
        }
        else {
          this.selItem = { kind: 'artist', value: this.artists[0] }
          this.canGo = true
        }
      } 
      else {
        this.artists = []
        this.styles = []
      }
      this.showResults = (this.styles.length + this.artists.length > 0)
      this.handleScroll()
    },
    clearSearch: function () {
      this.search = ''
    },
    switchKind: function () {
      if(this.selItem.kind === 'artist') {
        if(this.styles.length > 0) {
          this.selItem.value = this.styles[0]
          this.selItem.kind = 'style'
        }
      }
      else if(this.selItem.kind === 'style') {
        if(this.artists.length > 0) {
          this.selItem.value = this.artists[0]
          this.selItem.kind = 'artist'
        }
      }
    },
    selDown: function () {
      if(this.selItem.kind === 'artist') {
        if(this.artists.length > 0) {
          for(let i = 0; i < this.artists.length; i++)
          {
            if(this.artists[i].artist_id === this.selItem.value.artist_id) {
              if(this.artists.length > (i+1)){
                this.selItem.value = this.artists[i+1]
                return;
              }
            }
          }
        }
      }
      else if(this.selItem.kind === 'style') {
        if(this.styles.length > 0) {
          for(let i = 0; i < this.styles.length - 1; i++)
          {
            if(this.styles[i].gallery_id === this.selItem.value.gallery_id) {
              if(this.styles.length > (i+1)){
                this.selItem.value = this.styles[i+1]
                return;
              }
            }
          }
        }
      }
    },
    selUp: function () {
      if(this.selItem.kind === 'artist'){
        if(this.artists.length > 0) {
          for(let i = 0; i < this.artists.length; i++)
          {
            if(this.artists[i].artist_id === this.selItem.value.artist_id) {
              if(i > 0){
                this.selItem.value = this.artists[i-1]
                return;
              }
            }
          }
        }
      }
      else if(this.selItem.kind === 'style') {
        if(this.styles.length > 0) {
          for(let i = 0; i < this.styles.length; i++)
          {
            if(this.styles[i].gallery_id === this.selItem.value.gallery_id) {
              if(i > 0){
                this.selItem.value = this.styles[i-1]
                return;
              }
            }
          }
        }
      }
    },
    handleGo: function () {
      if(this.selItem.kind === 'artist') {
        this.$ixr.push('/artists/' + this.selItem.value.portfolio_url)
      }
      else if(this.selItem.kind === 'style') {
        this.$ixr.push(this.selItem.value.url)
      }
      else {
        let message = this.$nippets.search.notFoundMessage
        if(!this.search) message = this.$nippets.search.pleaseEnter
        this.$store.commit('setMessage', 
        { 
          title: this.$nippets.search.search, 
          message: message, 
          show: true 
        })
      }
    }
  },
  watch:{
    search: function () {
      this.handleSearch()
    }
  }
  
}
</script>

<style scoped>
.search-h3{
  font-size:18px;
  font-weight:500;
  margin:0 0 6px;
  color:#8b6f4b;
}
.search-holder{
  display:inline-block;
  position:relative;

}

.narex .search-holder{
  margin-right:-20px;
}

.search-widget {
  border-radius:6px;
  border:1px solid #c8c8c8;
  background-color:#fff;
  display:inline-flex;
  overflow:hidden;
}

.search-widget.noline{
  border:none;
}


.search-widget:hover{
  border-color:#888;
}

.sel .search-widget{
  border-color:#444;
}

.search-col{
  margin:10px;
  line-height:26px;
  text-align:left;
}

.search-area{
  padding:10px;
  padding-right:0;
  font-size:14px;
  line-height:16px;
  font-weight:400;
  color:#666;
  min-width:205px;
  width:12vw;
  border:0;
}

.go-area{
  background-color:#a7aba1;
  color:#fff;
  font-size:17px;
  line-height:16px;
  font-weight:500;
  padding:10px;
  text-transform:uppercase;
  user-select: none;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.go-area.canGo{
  cursor:pointer;
  background-color:#ce0e2d;
}

.go-area.canGo:hover{
  background-color:#000;
}

.mag-area{
  background-repeat:no-repeat;
  background-image:url('../../assets/img/mag.svg');
  background-position:center center;
  background-size:23px;
  width:30px;
  margin-right:6px;
}

.search-results{
  position:absolute;
  top:100%;
  left:3px;
  padding:10px;
  min-width:calc(100% - 50px);
  background-color:#fff;
  z-index:46;
  box-sizing:border-box;
  display:flex;
  overflow-y:auto;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow:1px 1px 5px rgba(0,0,0,0.4);
}
.search-results.right{
  left:auto;
  right: 47px;
}

.close-area{
  background-image:url('../../assets/img/close.svg');
  background-position:center center;
  background-size:16px 16px;
  background-repeat:no-repeat;
  width:30px;
  cursor:pointer;
  opacity:0.6;
}

.close-area:hover{
  background-image:url('../../assets/img/close-red.svg');
  opacity:1;
}

.close-area.invis{
  background-image:none;
}

.search-results a{
  white-space:nowrap;
  color:#000;
  text-decoration: none;
  display:block;
}

.search-results a:hover{
  color:#ce0e2d;
}

.smallpoint{
  width: 16px;
  height: 16px;
}

@media screen and (max-width:1100px){
  .narex .search-holder{
    margin-right:0;
  }
}

@media screen and (max-width:767px){
  .search-area{
    padding:5px;
    min-width:150px;
  }
  .go-area{
    padding:7px;
  }
  .search-results{
    display:block;
  }
}

@media screen and (max-width:420px){
  .mag-area{
    display:none;
  }
}

</style>
